import * as React from 'react'
import { NavigationTabs, NavigationTabsButton } from '@components/navigation-tabs'
import { ScrollableModalTab, useModalWithScrollableTabs } from '@components/hooks/use-modal-with-scrollable-tabs'

type Tab = 'data' | 'history' | 'codes' | 'notes'

interface RefObject<T> {
  readonly current: T | null
}

interface Props {
  dataRef: RefObject<HTMLElement>
  historyRef: RefObject<HTMLElement>
  codesRef: RefObject<HTMLElement>
  notesRef: RefObject<HTMLElement>
}

export const PromocodeTouristVoucherDetailsTabs: React.FC<Props> = ({ dataRef, codesRef, notesRef, historyRef }) => {
  const [tab, setTab] = React.useState<Tab>('data')

  const tabs: ScrollableModalTab<Tab>[] = [
    { ref: dataRef, name: 'data' },
    { ref: historyRef, name: 'history' },
    { ref: notesRef, name: 'notes' },
    { ref: codesRef, name: 'codes' },
  ]

  const { handleTabClick } = useModalWithScrollableTabs<Tab>({
    modalId: 'promocode-tourist-voucher-details-dialog',
    setTab,
    tabs,
  })

  const buttons: NavigationTabsButton[] = [
    {
      title: 'Dane podstawowe i voucher',
      isActive: tab == 'data',
      onClick: handleTabClick('data'),
    },

    {
      title: 'Historia',
      isActive: tab == 'history',
      onClick: handleTabClick('history'),
      isSuperuser: true,
    },
    {
      title: 'Notatki',
      isActive: tab == 'notes',
      onClick: handleTabClick('notes'),
    },
    {
      title: 'Kod obsługi płatności',
      isActive: tab == 'codes',
      onClick: handleTabClick('codes'),
    },
  ]

  return (
    <div className="modal-details__tabs-wrapper">
      <NavigationTabs buttons={buttons} />
    </div>
  )
}
